import Vue from "vue";
import Router from "vue-router";
import Main from "@/components/Main";
import store from "../../store/store";
import common from "../../utils/common";

import SurveyAnswer from "@/components/survey/surveyAnswer.vue"; //查看问卷

Vue.use(Router);

const vueRouter = new Router({
  routes: [
    {
      path: "/#/",
      name: "main",
      component: Main,
      children: [
        {
          path: "/study/center", // 学习中心
          name: "studyCenter",
          components: {
            helper: resolve => require(["@/components/study/center"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/study/schedule", // 课程安排
          name: "schedule",
          components: {
            helper: resolve => require(["@/components/study/schedule"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/study/timeTableSelect", // 固选课订课
          name: "timeTableSelect",
          components: {
            helper: resolve =>
              require(["@/components/study/timeTableSelect"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/study/salonInfo", // 沙龙详情
          name: "salonInfo",
          components: {
            helper: resolve =>
              require(["@/components/study/salonInfo"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/study/bookLessonSelect", // 自选课选择主题
          name: "bookLessonSelect",
          components: {
            helper: resolve =>
              require(["@/components/study/bookLessonSelect"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/study/teacherSelect",
          name: "teacherSelect",
          components: {
            helper: resolve =>
              require(["@/components/study/teacherSelect"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/study/bookSmallClassSelect", // 小班课选择主题
          name: "bookSmallClassSelect",
          components: {
            helper: resolve =>
              require(["@/components/study/bookSmallClassSelect"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/study/bookLessonInfo", // 主题（教案）详情
          name: "bookLessonInfo",
          components: {
            helper: resolve =>
              require(["@/components/study/bookLessonInfo"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/study/bookSmallClassInfo", // 小班课主题详情
          name: "bookSmallClassInfo",
          components: {
            helper: resolve =>
              require(["@/components/study/bookSmallClassInfo"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/study/bookTimeSelect", // 选择时间
          name: "bookTimeSelect",
          components: {
            helper: resolve =>
              require(["@/components/study/bookTimeSelect"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/study/bookConfirm", // 订课详情
          name: "bookConfirm",
          components: {
            helper: resolve =>
              require(["@/components/study/bookConfirm"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/course/courseware", // 查看附件
          name: "courseware",
          components: {
            helper: resolve =>
              require(["@/components/course/courseware"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        //eval下的
        {
          path: "/eval/evalTeaching", // 评价教师
          components: {
            helper: resolve =>
              require(["@/components/eval/evalTeaching"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/eval/teacherOverallEval", // 查看给教师的评价
          components: {
            helper: resolve =>
              require(["@/components/eval/teacherOverallEval"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/eval/variousEval", // 各种评价
          components: {
            helper: resolve =>
              require(["@/components/eval/variousEval"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/my/accountSettings", // 账号设置
          name: "accountSettings",
          components: {
            helper: resolve =>
              require(["@/components/my/accountSettings"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/my/endedCourse", // 已结束课程
          name: "endedCourse",
          components: {
            helper: resolve => require(["@/components/my/endedCourse"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/my/notice", // 我的消息
          name: "notice",
          components: {
            helper: resolve => require(["@/components/my/notice"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/my/noticeDetail", // 消息详情
          name: "noticeDetail",
          components: {
            helper: resolve =>
              require(["@/components/my/noticeDetail"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/my/outerChain", // 公告外链页面
          components: {
            helper: resolve => require(["@/components/my/outerChain"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/my/myJoin", // 我参与的
          components: {
            helper: resolve => require(["@/components/my/myJoin"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/my/favoriteTeacher", // 优选 老师
          components: {
            helper: resolve =>
              require(["@/components/my/favoriteTeacher"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/my/myScholarship", // 奖学金
          components: {
            helper: resolve =>
              require(["@/components/my/myScholarship"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/my/editUserInfo", // 修改我的信息
          components: {
            helper: resolve =>
              require(["@/components/my/editUserInfo"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/my/resetPassword", // 修改密码
          components: {
            helper: resolve =>
              require(["@/components/my/resetPassword"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/my/myExam", // 考试
          components: {
            helper: resolve => require(["@/components/my/myExam"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/my/collect", // 收藏
          components: {
            helper: resolve => require(["@/components/my/collect"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/my/competition", // 训练营&竞赛
          components: {
            helper: resolve => require(["@/components/my/competition"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/my/browsingHistory",
          components: {
            helper: resolve =>
              require(["@/components/my/browsingHistory"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/word/myWord", // 我的单词本
          components: {
            helper: resolve => require(["@/components/word/myWord"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },

        {
          path: "/survey/survey-answer/:id?/:surveyId?/:surveyAnswerId", //问卷回答  /:id
          name: "surveyAnswer",
          components: {
            helper: SurveyAnswer
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        // 问卷回答
        {
          path: "/survey/questionnaireAnswer", //问卷回答 作答
          name: "QuestionnaireAnswer",
          components: {
            helper: resolve =>
              require(["@/components/survey/questionnaireAnswer"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        // 阶段性课程反馈
        {
          path: "/survey/personAnswer", // 阶段性课程反馈初始化
          name: "personAnswer",
          components: {
            helper: resolve =>
              require(["@/components/survey/personAnswer"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        //neo NeoBox
        {
          path: "/neo/neoBox", // neoiframe
          components: {
            helper: resolve => require(["@/components/neo/neoBox"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        //  跟进列表
        {
          path: "/follow/list",
          components: {
            helper: resolve => require(["@/components/follow/list"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        //  跟进反馈
        {
          path: "/follow/feedback",
          components: {
            helper: resolve =>
              require(["@/components/follow/feedback"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        //#region 竞赛
        {
          path: "/competition/info", // 竞赛详情
          components: {
            helper: resolve =>
              require(["@/components/competition/info"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        //竞赛排名
        {
          path: "/competition/myRankResult",
          components: {
            helper: resolve =>
              require(["@/components/competition/myRankResult"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        // 竞赛获奖
        {
          path: "/competition/winnerList",
          components: {
            helper: resolve =>
              require(["@/components/competition/winnerList"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        // 竞赛系列
        {
          path: "/competition/competitionSeries",
          components: {
            helper: resolve =>
              require(["@/components/competition/competitionSeries"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        //#endregion
        {
          path: "/certificate/myCertificate", // 我的证书
          name: "myCertificate",
          components: {
            helper: resolve =>
              require(["@/components/certificate/myCertificate"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/certificate/certificateLevel", // 证书等级
          name: "certificateLevel",
          components: {
            helper: resolve =>
              require(["@/components/certificate/certificateLevel"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/iframe/competitionBox",
          name: "iframeCompetitionBox",
          components: {
            helper: resolve =>
              require(["@/components/iframe/competitionBox"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/robot/intermediate", // 小智中间键页面
          name: "robotIntermediate",
          components: {
            helper: resolve =>
              require(["@/components/robot/intermediate"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/learning/index", // 畅学
          name: "learningIndex",
          components: {
            helper: resolve => require(["@/components/learning/index"], resolve)
          },
          meta: {
            requireAuth: false
          }
        },
        {
          path: "/learning/middle", // 畅学中间页
          name: "learningMiddle",
          components: {
            helper: resolve =>
              require(["@/components/learning/middle"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/learning/middle1", // 畅学中间页
          name: "learningMiddle1",
          components: {
            helper: resolve =>
              require(["@/components/learning/middle1"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: false
          }
        },
        {
          path: "/mc/microCourseList", // 轻课
          name: "microCourseList",
          components: {
            helper: resolve =>
              require(["@/components/mc/microCourseList"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/mc/videoList", // 视频课列表
          name: "videoList",
          components: {
            helper: resolve => require(["@/components/mc/videoList"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/mc/microCoursDetail", // 轻课详情
          name: "microCoursDetail",
          components: {
            helper: resolve =>
              require(["@/components/mc/microCoursDetail"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/mc/microLessonDetail", // 课时详情
          name: "microLessonDetail",
          components: {
            helper: resolve =>
              require(["@/components/mc/microLessonDetail"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/mc/videoDetail", // 视频课详情
          name: "videoDetail",
          components: {
            helper: resolve => require(["@/components/mc/videoDetail"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/read/planList", // 阅读计划列表
          name: "planList",
          components: {
            helper: resolve => require(["@/components/read/planList"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/read/plan", // MS4902-阅读计划详情
          name: "plan",
          components: {
            helper: resolve => require(["@/components/read/plan"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/read/preClassReading", // 课前导读
          name: "preClassReading",
          components: {
            helper: resolve =>
              require(["@/components/read/preClassReading"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/read/article", // 原文听读
          name: "article",
          components: {
            helper: resolve => require(["@/components/read/article"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/read/articlePerusal", // 精读讲解
          name: "articlePerusal",
          components: {
            helper: resolve =>
              require(["@/components/read/articlePerusal"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/read/articleProgress", // 文章完成
          name: "articleProgress",
          components: {
            helper: resolve =>
              require(["@/components/read/articleProgress"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/mc/payment", // 支付页
          name: "plan",
          components: {
            helper: resolve => require(["@/components/mc/payment"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/word/wordCard", // 词卡
          name: "wordCard",
          components: {
            helper: resolve => require(["@/components/word/wordCard"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/oralT/themePage", // 天天练列表
          name: "themePage",
          components: {
            helper: resolve =>
              require(["@/components/oralT/themePage"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/oralT/theme", // 天天练详情
          name: "theme",
          components: {
            helper: resolve => require(["@/components/oralT/theme"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/oralT/daily", // 句子详情
          name: "daily",
          components: {
            helper: resolve => require(["@/components/oralT/daily"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/oralT/sort", // 热门推荐 最近更新
          name: "sort",
          components: {
            helper: resolve => require(["@/components/oralT/sort"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/oralT/list", // 标签对应专题列表
          name: "list",
          components: {
            helper: resolve => require(["@/components/oralT/list"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/user/login",
          name: "loginPage",
          components: {
            helper: resolve => require(["@/components/learning/index"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: false
          }
        },
        {
          path: "/coupon/couponList", // 优惠券
          name: "couponList",
          components: {
            helper: resolve =>
              require(["@/components/coupon/couponList"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/order/orderList", // 课程订单
          name: "orderList",
          components: {
            helper: resolve =>
              require(["@/components/order/orderList"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/free/freeLearningCardBuying", // 购买畅学卡
          name: "freeLearningCardBuying",
          components: {
            helper: resolve =>
              require(["@/components/free/freeLearningCardBuying"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/free/:companyID", //三花购买畅学卡
          name: "freeCardBuying",
          components: {
            helper: resolve =>
              require(["@/components/free/freeCardBuying"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/free/crm/:companyID", // Crm购买畅学卡
          name: "freeCardBuyingCrm",
          components: {
            helper: resolve =>
              require(["@/components/free/freeCardBuyingCrm"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/extensiveRead/articleDetails", // 泛读详情
          name: "articleDetails",
          components: {
            helper: resolve =>
              require(["@/components/extensiveRead/articleDetails"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/extensiveRead/plan", // 泛读专题目录
          name: "plan",
          components: {
            helper: resolve =>
              require(["@/components/extensiveRead/plan"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/follow/peakingEvaluate", // 口测评价
          name: "peakingEvaluate",
          components: {
            helper: resolve =>
              require(["@/components/follow/peakingEvaluate"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/learningGoal/subscribed", // 已订阅课程
          name: "subscribed",
          components: {
            helper: resolve =>
              require(["@/components/learningGoal/subscribed"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/learningGoal/learningSearchResult", // PS0001.5-搜索结果
          name: "learningSearchResult",
          components: {
            helper: resolve =>
              require([
                "@/components/learningGoal/learningSearchResult"
              ], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: "/aitse/aitseBox",
          name: "aitse",
          components: {
            helper: resolve =>
              require(["@/components/aispeakingtest/aitseBox"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        },
        {
          path: `/my/examRecord`,
          name: "examRecord",
          components: {
            helper: resolve => require(["@/components/my/examRecord"], resolve)
          },
          meta: {
            keepAlive: false,
            requireAuth: true
          }
        }
      ]
    },

    {
      path: "/user/wxLogin",
      name: "wxLogin",
      component: resolve => require(["@/components/user/wxLogin"], resolve)
    },
    {
      path: "/study/courseWares",
      name: "courseWares", // ppt,pdf,pptx课件
      component: resolve => require(["@/components/study/courseWares"], resolve)
    },
    {
      path: "/study/courseWares2",
      name: "courseWares2", // 音频/图片/视频课件
      component: resolve =>
        require(["@/components/study/courseWares2"], resolve)
    }
  ]
});
//#region 面包削组件
vueRouter.beforeEach((to, from, next) => {
  if (typeof _hmt != "undefined" && _hmt) {
    if (to.path) {
      let suburl = `/${common.systemKey}/#`;
      _hmt.push(["_trackPageview", suburl + to.fullPath]);
    }
  }

  let storeArr = store.getters["common/breadcrumbUrlArr"];
  let startPageArr = store.getters["common/breadStartPage"];
  let arr = [];

  arr = arr.concat(storeArr);

  let idx = arr.findIndex(i => i.url === to.path);

  console.log(`----------init`, arr);
  if (idx >= 0) {
    arr = arr.slice(0, idx);
    console.log(`----------slice`, arr);
  } else if (startPageArr.includes(to.path)) {
    store.commit("common/SETMENUCURSTATE", to.path);
    console.log(`---------empty`, arr);
    arr = [];
  } else if (from.path !== "/") {
    arr.push({
      url: from.path,
      query: from.query
    });
    console.log(`----------push`, arr);
  }

  store.commit("common/SETBREADCRUMBURLARR", arr);
  let flag = localStorage.getItem("commonToken");
  let token = false;
  if (flag) {
    if (flag.indexOf("Session") >= 0) {
      token = true;
    }
  }

  if (to.path === "/") {
    vueRouter.push({
      path: "/learning/index"
    });
    next();
  }
  if (to.meta.requireAuth) {
    if (token) {
      next();
    } else {
      localStorage.setItem("locationReash", 1);
      next({
        path: "/learning/index"
      });
    }
  } else {
    next();
  }
});
//#endregion
export default vueRouter;



// WEBPACK FOOTER //
// ./src/router/index.js